import { combineReducers } from 'redux';
import undoable from 'redux-undo';
import {
  TEMPLATE_UPDATE_BASIC_ELEMENTS_PROPERTIES_GROUPED_HISTORY,
  TEMPLATE_UPDATE_SELECTED_FIELDPOSITION_COORDINATES_BY_OFFSET,
  TEMPLATE_UPDATE_SELECTED_ITEMS_COORDINATES_BY_OFFSET
} from './actions';
import editor from './reducers/editor';
import template from './reducers/template';
import { TemplateEditorAction, TemplateState } from './templateeditor-types';

export default combineReducers({
  editor,
  template: undoable(template, {
    limit: 20,
    filter: (action: TemplateEditorAction) => action.undoable,
    ignoreInitialState: true,
    syncFilter: true,
    groupBy
  })
});

export function groupBy(action: TemplateEditorAction, currentState: TemplateState): string {
  const { type, batchUndoId } = action;

  if (type === TEMPLATE_UPDATE_SELECTED_ITEMS_COORDINATES_BY_OFFSET || type === TEMPLATE_UPDATE_SELECTED_FIELDPOSITION_COORDINATES_BY_OFFSET) {
    if (!currentState.selection?.fieldPositions && !currentState.selection?.elements) {
      return type;
    }

    const fieldMap = currentState.selection?.fieldPositions?.map((fp) => `${fp[2]}_${fp[4]}`) || [];
    const elementsMap = currentState.selection?.elements?.map((fp) => `${fp[2]}_${fp[4]}`) || [];

    // create an array of action.type and `_` joined pieces of field positions & elements
    const groupName = [type, ...fieldMap, ...elementsMap];

    // join them together with `_`. i.e.: TYPE_0_0_1_0.
    return groupName.join('_');
  }

  if (type === TEMPLATE_UPDATE_BASIC_ELEMENTS_PROPERTIES_GROUPED_HISTORY) {
    // create an array of action.type and `_` joined pieces of basic elements
    // join them together with `_`. i.e.: TEMPLATE_UPDATE_BASIC_ELEMENTS_PROPERTIES_GROUPED_HISTORY_EVENTID_0_0_1_0.
    return [type, action?.payload?.eventId, ...(currentState?.selection?.elements?.map((fp) => `${fp[2]}_${fp[4]}`) || [])].join('_');
  }

  // if the action has a batchUndoId, use it to group the action
  if (batchUndoId) {
    return `${type}_${batchUndoId}`;
  }

  return null;
}
